export const legacyEmployeeRouteMap: Record<string, string> = {
  '/employee-workbench': '/employee-center/overview',
  '/approval': '/employee-center/approval',
  '/employee': '/employee-center/employees',
  '/employee/new': '/employee-center/employees/new',
  '/employee/recycle-bin': '/employee-center/employees/recycle-bin',
  '/employee/:uuid': '/employee-center/employees/:uuid',
  '/onboarding': '/employee-center/lifecycle/onboarding',
  '/regularization': '/employee-center/lifecycle/regularization',
  '/employee-change': '/employee-center/lifecycle/employee-change',
  '/resignation': '/employee-center/lifecycle/resignation',
  '/employee-lifecycle-audits': '/employee-center/lifecycle-audits',
  '/labor-relations': '/employee-center/relations/labor-relations',
  '/certificate-requests': '/employee-center/relations/certificate-requests',
  '/employee-relations-analysis': '/employee-center/relations/analysis',
  '/position-settings': '/settings/employee/position-settings',
  '/job-level-settings': '/settings/employee/job-level-settings',
  '/work-location-settings': '/settings/employee/work-location-settings',
  '/handover-templates': '/settings/employee/handover-templates',
  '/employee-reminder-settings':
    '/settings/employee/employee-reminder-settings',
  '/workflow-integration-settings':
    '/settings/employee/workflow-integration-settings',
};
for (const name of [
  'onboarding',
  'regularization',
  'employee-change',
  'resignation',
]) {
  for (const tail of ['new', ':uuid/edit', ':uuid/view']) {
    legacyEmployeeRouteMap[`/${name}/${tail}`] =
      `/employee-center/lifecycle/${name}/${tail}`;
  }
}

export function resolveEmployeeManagementLink(
  value: string,
): string | undefined {
  // Only accept known application-relative destinations.
  if (!value.startsWith('/') || value.startsWith('//')) return undefined;
  const url = new URL(value, 'https://hr.invalid');
  const path = url.pathname.replace(/^\/zy-hr(?=\/|$)/, '') || '/';
  if (path === '/' || path === '/employee-center')
    return `/employee-center${url.search}${url.hash}`;
  for (const [oldPath, destination] of Object.entries(legacyEmployeeRouteMap)) {
    const oldParts = oldPath.split('/');
    const parts = path.split('/');
    if (oldParts.length !== parts.length) continue;
    if (
      !oldParts.every((part, index) =>
        part === ':uuid' ? Boolean(parts[index]) : part === parts[index],
      )
    )
      continue;
    const uuid = parts[oldParts.indexOf(':uuid')];
    return `${destination.replace(':uuid', uuid || '')}${url.search}${url.hash}`;
  }
  if (
    path.startsWith('/employee-center/') ||
    path.startsWith('/settings/employee/')
  )
    return `${path}${url.search}${url.hash}`;
  return undefined;
}
